import { Component, Input } from '@angular/core';

@Component({
  selector: 'ai-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
})
export class LandingPageComponent {
  public currentStep = 0;
  @Input() isExplorePage: boolean = false;

  ngOnInit() {
    this.startMessageSequence();
  }

  /**
   * @function startMessageSequence
   * this method is used to render loader
  */
  public startMessageSequence() {
    const steps = [1, 2, 3];
    let index = 0;
    const nextStep = () => {
      if (index < steps.length) {
        this.currentStep = steps[index++];
        setTimeout(() => {
          nextStep();
        }, 2000);
      }
    };
    nextStep();
  }
}
